module.exports = __webpack_public_path__ + "static/media/project_logo.26e52cd1.svg";